var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { jsx } from "react/jsx-runtime";
import { Flex } from "antd";
import { ReactComponent as PlayIcon } from "./../../assets/icons/play-icon.svg";
const wrapperSizes = {
  sm: { width: 18, height: 18 },
  md: { width: 56, height: 56 },
  lg: { width: 80, height: 80 }
};
const iconSizes = {
  sm: { width: 7, height: 8 },
  md: { width: 25.7, height: 28 },
  lg: { width: 36, height: 40 }
};
const VideoPlayButton = ({
  wrapperStyle = {},
  iconStyle = {},
  size = "md"
}) => {
  return /* @__PURE__ */ jsx(
    Flex,
    {
      style: __spreadValues(__spreadValues({
        borderRadius: "50%",
        background: size === "sm" ? "rgba(255, 255, 255, 0.50)" : "rgba(0, 0, 0, 0.25)",
        backdropFilter: "blur(5px)"
      }, wrapperSizes[size]), wrapperStyle),
      align: "center",
      justify: "center",
      children: /* @__PURE__ */ jsx(
        PlayIcon,
        {
          style: __spreadValues(__spreadValues({
            transform: "translateX(5%)"
          }, iconSizes[size]), iconStyle)
        }
      )
    }
  );
};
var stdin_default = VideoPlayButton;
export {
  stdin_default as default
};
